import DealerSettings from "./DealerSettings";
export default DealerSettings;
